import AddBoxIcon from "@mui/icons-material/AddBox";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { styled, Theme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { 
  MRT_ToggleFullScreenButton as ToggleFullScreenButton, 
  MRT_ToggleGlobalFilterButton as ToggleGlobalFilterButton, 
  MRT_ToggleFiltersButton as ToggleFiltersButton,
  MRT_ShowHideColumnsButton as ShowHideColumnsButton,
  MRT_ToggleDensePaddingButton as ToggleDensePaddingButton,
  type MRT_TableInstance 
} from "material-react-table";
import { useCallback } from "react";
import { useNavigate } from "react-router";
import { useSession } from "users/__session/session-context";
import { FeeScheduleTemplateLoadIssue } from "work/fee-schedule-templates/_store/fee-schedule-templates-redux-slice";
import { PageTab } from "work/fee-schedule-templates/_views/pages/tabs";
import FeeScheduleTemplate from "work/fee-schedule-templates/fee-schedule-template";

const ToolbarButtonsContainer = styled("div")(({ theme }) => ({
  [theme.breakpoints.down("md")]: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
  },
  display: "flex",
  alignItems: "end",
  flexDirection: "column",
  gap: theme.spacing(1),
}));
const ToolbarButtons = styled("div")(() => ({
  display: "flex",
  alignItems: "end",
  flexWrap: "nowrap",
}));
const NewButton = styled(IconButton)(() => ({
  padding: 0,
}));

type FeeScheduleInternalActionsToolbarProps = {
  table: MRT_TableInstance<FeeScheduleTemplate | FeeScheduleTemplateLoadIssue>;
};

export default function FeeScheduleInternalActionsToolbar(props: Readonly<FeeScheduleInternalActionsToolbarProps>) {
  const { table } = props;

  const session = useSession();
  const navigate = useNavigate();
  const isMediumDisplaySize = useMediaQuery((theme: Theme) => theme.breakpoints.down("md"));

  const handleCreateClick = useCallback(() => {
    navigate(`/fee-schedules/${PageTab.Templates}/create`);
  }, [navigate]);

  return (
    <>
      {!isMediumDisplaySize && (
        <ToolbarButtonsContainer>
          <ToolbarButtons>
            <ToggleGlobalFilterButton table={table} />
            <ToggleFiltersButton table={table} />
            <ShowHideColumnsButton table={table} />
            <ToggleDensePaddingButton table={table} />
            <ToggleFullScreenButton table={table} />
          </ToolbarButtons>
          <Button
            startIcon={<AddBoxIcon />}
            disabled={session.user?.isSuperUser}
            onClick={handleCreateClick}
          >
            Create Fee Schedule
          </Button>
        </ToolbarButtonsContainer>
      )}
      {isMediumDisplaySize && (
        <NewButton color="primary" onClick={handleCreateClick}>
          <AddBoxIcon fontSize="large" />
        </NewButton>
      )}
    </>
  );
}
